<div class="main-container">
    <div class="modal-header">
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(false);$event.stopPropagation()">
        <span class="modal-main-title">{{data.title.key | translate}}</span>
    </div>
    <div class="modal-body" (click)="$event.stopPropagation()">
        <div class="statement-card">
            <img *ngIf="data.reportedStatement?.type === 'open'" class="statement-icon" src="../../../assets/svg/statement-icon-gray.svg">
            <img *ngIf="data.reportedStatement?.type !== 'open'" class="statement-icon" src="../../../assets/svg/statement-icon-{{data.reportedStatement?.color}}.svg">
            <span class="statement-title" [innerHTML]="data.reportedStatement?.title"></span>
        </div>

        <div class="reasons-container">
            <span class="reasons-container-title">{{data.reasonQuestionTitle.key | translate}}</span>

            <div class="reason" *ngFor="let reason of data.reasons">
                <input type="checkbox" class="form-check-input" [id]="'reason-' + reason.uuid"
                    [checked]="!!selectedReasons[reason.uuid]"
                    (change)="toggleReason(reason.uuid)">
                <label class="reason-label" [for]="'reason-' + reason.uuid">{{reason.reason}}</label>
            </div>

            <div class="reason">
                <input type="checkbox" class="form-check-input" id="reason-other"
                    [checked]="otherSelected"
                    (change)="toggleOther()">
                <label class="reason-label" for="reason-other">{{'report_statement_modal_other_reason_label' | translate}}</label>
            </div>

            <div *ngIf="otherSelected" class="other-reason-input-container">
                <textarea class="other-reason-input"
                    [appAutofocus]="otherSelected"
                    [(ngModel)]="otherReason"
                    (ngModelChange)="onOtherReasonChange()"
                    maxlength="300"
                    [placeholder]="('report_statement_modal_other_reason_placeholder' | translate)">
                </textarea>
            </div>
        </div>

        <div class="note-container">
            <i class="bi bi-question-circle-fill text-warning dn-question-icon"></i>
            <span class="note-text" [innerHTML]="(data.warning.key | translate)"></span>
        </div>

        <div class="buttons-container">
            <button pButton [ngClass]="button.className" [label]="(button.labelKey | translate)"
                *ngFor="let button of data.buttons"
                [disabled]="button.value && !canSubmit"
                (click)="close(button.value);$event.stopPropagation()"></button>
        </div>
    </div>
</div>
